module.exports = __webpack_public_path__ + "media/pet-paradise.488e1cab.mp4";